export default "__VITE_ASSET__C1LuXuHi__"